import emailjs from "emailjs-com";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "./firebaseConfig";

function AuthForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  try {
    if (isLogin) {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/dashboard");
    } else {
      await createUserWithEmailAndPassword(auth, email, password);

      emailjs
        .send(
          "service_uknp0wu", 
          "template_yozuubn", 
          { user_email: email },
          "cmFgKdWZ6FJLjNgqv"
        )
        .then(() => console.log("Welcome email sent!"))
        .catch((error) => console.error("Error sending email:", error));

      navigate("/dashboard");
    }
  } catch (error) {
    alert(error.message);
  } finally {
    setLoading(false);
  }
};


  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(to bottom right, #f5f5f3, #e3e9e3)",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "40px 50px",
          borderRadius: "12px",
          boxShadow: "0 6px 16px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          width: "350px",
        }}
      >
        <h2 style={{ color: "#3b3b3b", marginBottom: "20px" }}>
          {isLogin ? "Creator Flow" : "Create Your Account ✨"}
        </h2>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              width: "100%",
              padding: "10px 12px",
              marginBottom: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              width: "100%",
              padding: "10px 12px",
              marginBottom: "20px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
            required
          />

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              backgroundColor: loading ? "#a5b6a1" : "#6b8a78",
              color: "white",
              padding: "10px",
              border: "none",
              borderRadius: "6px",
              cursor: loading ? "not-allowed" : "pointer",
              transition: "background-color 0.3s ease",
              fontWeight: "bold",
              fontSize: "15px",
            }}
            onMouseEnter={(e) => !loading && (e.target.style.backgroundColor = "#587362")}
            onMouseLeave={(e) => !loading && (e.target.style.backgroundColor = "#6b8a78")}
          >
            {loading ? "Please wait..." : isLogin ? "Login" : "Sign Up"}
          </button>
        </form>

        <button
          onClick={() => setIsLogin(!isLogin)}
          style={{
            background: "none",
            border: "none",
            color: "#6b8a78",
            marginTop: "15px",
            cursor: "pointer",
            fontSize: "14px",
            textDecoration: "underline",
          }}
        >
          {isLogin
            ? "Don’t have an account? Sign up"
            : "Already have an account? Log in"}
        </button>
      </div>
    </div>
  );
}

export default AuthForm;
